import React from "react";
import BackgroundPhoto from "../Components/BackgroundPhoto";

export default function AccountBlocked() {
  document.title = "Onboarding";
  return (
    <BackgroundPhoto>
      <h5>We have had to temporarily block access to your account.</h5>
      <h5>We will let you know by email once unblocked.</h5>
    </BackgroundPhoto>
  );
}
